import clsx from 'clsx';
import React from 'react';
import { Button, ButtonProps, Icon, IconProps, Tooltip } from '../index';

type Props = ButtonProps<'button'> & {
  children?: React.ReactNode;
  iconClassName?: string;
  iconAlign?: 'left' | 'right' | 'middle';
  iconSize?: IconProps['size'];
  iconColor?: IconProps['color'];
  tooltip?: React.ReactNode;
} & Pick<IconProps, 'transform' | 'icon' | 'family'>;

const IconButton = ({
  icon,
  family,
  iconSize,
  iconColor,
  iconAlign = 'left',
  iconClassName,
  transform,
  tooltip,
  children,
  isLoading,
  ref,
  ...rest
}: Props) => {
  const content = (
    <Button {...rest} disabled={rest.disabled || isLoading} ref={ref}>
      {iconAlign === 'right' && children}
      <Icon
        icon={isLoading ? 'spinner' : icon}
        size={iconSize}
        color={iconColor}
        className={clsx(iconClassName, {
          'me-1': children && iconAlign === 'left',
          'ms-1': children && iconAlign === 'right',
        })}
        transform={transform}
        family={family}
      />
      {iconAlign === 'left' || iconAlign === 'middle' ? children : false}
    </Button>
  );
  if (tooltip) {
    return (
      <Tooltip placement={'top'} label={tooltip}>
        <div className='theme-control-toggle-label'>{content}</div>
      </Tooltip>
    );
  }
  return <>{content}</>;
};

export default IconButton;
